<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            <i>"Meeting the world in One Place"</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class=" specHeading uk-text-center"><span>International Student Services</span></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>

            <div>
              <p class="">
                The Office of International Student Services (ISS)
                gladly welcomes you to Northern Caribbean
                University (NCU)- and Jamaica!

                ISS serves to cater to your needs as an international
                student at NCU. As you begin your journey with us –
                at your new home away from home- we invite you to
                take note of the information in this short orientation
                brochure.
              </p>
              <p class="">
                The Office of International Student Services (ISS) is responsible
                for assisting international students with their concerns. Currently,
                there are approximately 160 international students and 30
                international countries represented at NCU.

              </p>
            </div>
            <div>
              <img class="uk-align-center" src="../assets/iss.jpeg" alt="">


                <a class="uk-button uk-button-secondary uk-align-center" target="_blank" href="/NCU_International_Students_update.pdf">Download ISS Handbook <span uk-icon="download"></span></a>

            </div>
          </div>
        </div>
      </div>
      <div class="uk-padding uk-background-muted">

        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-1@m" uk-grid>

            <div>
              <h2 class="uk-heading-bullet specHeading "><span>Extension Of Stay (Student Visa)</span></h2>
              <p class="uk-text-small uk-text-danger">
                All new international students are expected to report to the ISS Office within the first week of arrival in Jamaica.</p>
              <p class="uk-text-lead specHeading "><span>Processing of Application for Extension of Stay as a Student</span></p>
              <p class="">

              Upon arrival, an international student is landed as a visitor and is thereafter
              required to acquire an Extension of Stay from the Passport Immigration and
              Citizenship Agency (PICA) where his/her status is changed to that of a student.
              This entire process is facilitated by the Office of International Student Services
              where documents will be vetted then submitted to and collected from PICA on
              behalf of the students.
              </p>
              <ul class="uk-list uk-list-bullet ">
                Requirements for application as stated by the PICA are:
                <li>A valid passport for at least six (6) months;</li>
                <li>Letter of registration from the educational institution addressed to the
                  Chief Executive Officer;</li>
                <li>Completed Extension of Stay Application form;</li>
                <li>A non-refundable processing fee of JM$10,000. For additional information
                  on processing fees, please visit the PICA website at
                  http://www.pica.gov.jm/immigration/processing-fee/</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <div class="uk-padding">

        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>

            <div>
              <p class="uk-text-lead specHeading "><span>International Students Association</span></p>
              <p class="">

                The International Students’ Association (ISA) is a
                social club designated for international students. All
                international students automatically become
                members upon enrollment at NCU. Meetings are
                held every other Tuesday at 2:00pm. The ISA hosts
                and participates in various events both on and off
                campus.
              </p>


            </div>
            <div>
              <p class="uk-text-lead specHeading "><span>International Diversity Weekend</span></p>
              <p class="">

                International Diversity Weekend is an
                annually calendared NCU event which
                showcases and celebrates the
                international countries and cultures
                represented on campus.
              </p>
            </div>
            <div>
              <div class="uk-child-width-1-2@s uk-child-width-1-2@l " uk-grid>
                <div>
                  <img class="uk-border-circle" src="../assets/iss1.png" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/iss2.png" width="200" height="200" alt="Border circle">
                </div>
              </div>
            </div>
            <div>
              <div class=" uk-child-width-1-2@l uk-child-width-1-2@s" uk-grid>
                <div>
                  <img class="uk-border-circle" src="../assets/iss1.jpg" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/iss4.png" width="200" height="200" alt="Border circle">
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </transition>

</template>

<script>
    export default {
        name: "iss",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU International Students',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'International Students are welcomed at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h2
    {
      font-size: 1.1em !important;
    }
    h1
    {
      font-size: 1.2em !important;
    }
    p,li
    {
      font-size: 0.8em !important;
    }
 img
 {
   height:150px;
   width:150px;
   margin-left: 20%;
 }


  }
</style>
